<template>
    <div class="html-report" v-loading="isLoading">
        <iframe ref="iframe" :class="`iframe ${show?'':'hide'}`" :src="content" frameborder="0"></iframe>
    </div>
</template>

<script>
    export default {
        name: "user-html-report",
        data(){
            return {
                show: false,
                isLoading: false,
                content: null,
            }
        },
        methods: {
            $_get: async function(){
                this.show = false;
                this.isLoading = true;
                let params = {
                    history_id: this.$route.params.history_id,
                }
                let data = await this.$api.userAwrUnscramble.getReport.html.call(this, params);
                if(data !== false) {
                    this.content = data;
                } else {
                    this.isLoading = false;
                }
            },
            $_resetIframeHeight(){
                let iframe = this.$refs.iframe;
                iframe.setAttribute('height', iframe.contentWindow.document.body.scrollHeight);
                this.isLoading = false;
                this.show = true;
            },
        },
        watch: {
            content(){
                window.setTimeout(this.$_resetIframeHeight, 5000);
            },
        },
        created(){
            this.$_get();
        },
    }
</script>

<style lang="less" scoped>
    .html-report {
        position: relative;
        width: ~"calc(100%)";
        display: flex;
        justify-content: center;
        overflow: hidden;
        .iframe {
            min-width: 1000px;
        }
        .hide {
            visibility: hidden;
        }
    }
</style>